import { apiClient } from './client';
import { API_ENDPOINTS } from './endpoints';

/**
 * Home Dashboard API Types
 * Mirrors backend types from befit-backend/src/types/home.ts
 */

export interface HomeUserProfile {
  id: string;
  username: string | null;
  avatarUrl: string | null;
  walletAddress: string;
}

export interface WeekStats {
  workouts: number;
  distance: number;
  daysCompleted: number;
  totalDays: 7;
}

export interface MonthStats {
  activeDays: number;
  totalDistance: number;
  changePercentage: number;
  totalDays: number;
  /** Weekly distance data for chart [W1, W2, W3, W4, W5] in km */
  weeklyData: number[];
}

export interface NextGoal {
  challengeId: string;
  challengeName: string;
  challengeType: string;
  title: string;
  target: string;
  current: number;
  max: number;
  unit: string;
  icon: string;
  progressPercentage: number;
}

export interface UserStats {
  challengesWon: number;
  totalEarnings: number;
  totalActiveStakes: number;
  currentStreak: number;
}

export interface HomeChallengeCard {
  id: string;
  name: string;
  type: string;
  totalDays: number;
  dailyGoal: number;
  stakeAmount: number;
  participantCount: number;
  startDate: string;
  endDate: string;
  status: "upcoming" | "active" | "completed";
  isUserParticipant: boolean;
  /** True if the current user created this challenge */
  isUserCreator: boolean;
  currentDay: number;
  daysCompleted: number;
  progressPercentage: number;
}

export interface ChallengesSection {
  sectionTitle: string;
  sectionType: "user" | "upcoming" | "active" | "empty";
  challenges: HomeChallengeCard[];
}

export interface HomeDashboardData {
  user: HomeUserProfile;
  weekStats: WeekStats;
  monthStats: MonthStats;
  nextGoal: NextGoal | null;
  stats: UserStats;
  challengesSection: ChallengesSection;
  /**
   * True if user has NEVER participated in any challenge
   * Used to show welcome/onboarding screen for new users
   */
  isFirstTimeUser: boolean;
}

export const homeApi = {
  /**
   * Get home dashboard data
   * GET /api/home/dashboard
   */
  getDashboard: async (): Promise<HomeDashboardData> => {
    const response = await apiClient.get<{ success: boolean; data: HomeDashboardData }>(
      API_ENDPOINTS.HOME.DASHBOARD
    );
    return response.data.data;
  },
};
